
export const INPUTCHANGE = "flitebooking/inputchange";
export const BOOKEDFLITE = "flitebooking/bookflite";
export const DELETEBOOKING = "flitebooking/deletebooking";
export const DELETESELECTEDBOOKINGS = "flitebooking/deleteselectedbookings";
export const EDITBOOKING = "flitebooking/editbooking";
export const RESETBOOKINGS = "flitebooking/restbookings";
export const CHECKEDBOOKING = "flitebooking/checkedbooking";